import { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';

import { AppShell } from '@mantine/core';

import { useFeatureFlag } from '@/store/slices/api/featureFlagsApiSlice';
import { TOP_NAV_HEIGHT } from '@/utils/constants';
import SupportWidget from '@/components/SupportWidget';
import { TopNav } from '@/components/TopNav';
import { routes } from '@/routes';

export function MainAppShell({ children }: Readonly<{ children: ReactElement }>) {
  const location = useLocation();
  const isSupportWidgetEnabled = useFeatureFlag('supportWidget');

  // Determine if the current page is related to transmission reports.
  const isTransmissionReportPage =
    location.pathname.includes(routes.physician.reviewTransmissions) ||
    location.pathname.includes(routes.physician.editReport) ||
    /^\/physician\/transmissions\/\d+\/edit$/.test(location.pathname) ||
    location.pathname.includes(routes.physician.loadReport) ||
    /^\/physician\/transmissions\/\d+\/review$/.test(location.pathname);

  const paddingStyles = { px: 0, pt: 54, pb: 0 };

  return (
    <AppShell
      transitionDuration={500}
      transitionTimingFunction="ease"
      header={{
        height: TOP_NAV_HEIGHT,
        collapsed: isTransmissionReportPage
      }}
      padding="md">
      <AppShell.Header bg="plum.9" style={{ transition: 'height 0.3s ease-in-out' }}>
        <TopNav />
      </AppShell.Header>

      <AppShell.Main
        bg="plum.0"
        {...paddingStyles}
        style={{
          transition: 'padding-top 0.3s ease-in-out'
        }}>
        {children}
      </AppShell.Main>

      {isSupportWidgetEnabled && <SupportWidget />}
    </AppShell>
  );
}
